import { render, staticRenderFns } from "./CustomerSuccessCompaniesTab.vue?vue&type=template&id=3806b5d8&"
import script from "./CustomerSuccessCompaniesTab.vue?vue&type=script&lang=ts&"
export * from "./CustomerSuccessCompaniesTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports